import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import loginbg from "../Asset/background.jpg";
import { FaEye, FaEyeSlash } from "react-icons/fa";


export default function SignupPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!name || !mobile || !email || !password) {
      setError("All fields are required");
      return;
    }

    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(mobile)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    // const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
    // if (!gmailRegex.test(email)) {
    //   setError("Please enter a valid Gmail address (example@gmail.com)");
    //   return;
    // }
    const gmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!gmailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }


    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}user_signup.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_name: name,
          user_mail: email,
          user_mobile: mobile,
          user_password: password,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        alert("Signup successful! Please login to continue.");
        navigate("/login");
      } else {
        setError(data.head.msg || "Signup failed. Please try again.");
      }
    } catch (err) {
      console.error("Signup API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 bg-light"
      id="signup"
    >
      <div
        className="card p-4 shadow animate-card"
        style={{ width: "360px", borderRadius: "15px" }}
      >
        <h3 className="text-center mb-3 fw-bold">Create Account ✨</h3>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSignup}>
          <div className="mb-3 text-start">
            <label className="form-label">Full Name</label>
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Enter Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3 text-start">
            <label className="form-label">Mobile Number</label>
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="10-digit Phone Number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              maxLength="10"
              required
            />
          </div>

          <div className="mb-3 text-start">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control form-control-lg"
              placeholder="Enter Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* <div className="mb-3 text-start">
            <label className="form-label">Create Password</label>
            <input
              type="password"
              className="form-control form-control-lg"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div> */}
          <div className="mb-3 text-start">
  <label className="form-label">Create Password</label>

  <div className="position-relative">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control form-control-lg pe-5"
      placeholder="Enter Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
    />

    <span
      className="position-absolute top-50 end-0 translate-middle-y me-3"
      style={{ cursor: "pointer" }}
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </span>
  </div>
</div>

          <button
            className="btn btn-success w-100 fw-bold py-2"
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing Up..." : "Sign Up"}
          </button>
        </form>

        <p className="text-center mt-3 text-muted" style={{ fontSize: "14px" }}>
          Already have an account?{" "}
          <span
            className="text-primary fw-semibold"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/login")}
          >
            Login
          </span>
        </p>
      </div>

      {/* Animation Styles */}
      <style>{`
        #signup {
          background-image: url(${loginbg});
          background-size: cover;
          background-repeat: no-repeat;
          background-attachment: fixed;
        }
        .animate-card {
          animation: float 2.5s ease-in-out infinite;
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0px); }
        }
      `}</style>
    </div>
  );
}
